import { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";

import useCookie from "./usecookie.js";

const decodeJwt = (token) => {
    try {
        const decodedToken = jwtDecode(token);

        const now = Math.floor(Date.now() / 1000);
        if (decodedToken.exp < now) {
            return null;
            }

        if (decodedToken?.email?.startsWith("@")) {
            return null;
            }

        return decodedToken;
        } catch (error) {
            console.error("Error decoding token:", error);
            return null;
        }
    return null;
    }

const useUser = () => {

    const [idToken] = useCookie("id_token", "");
    const [userInfo, setUserInfo] = useState(() => decodeJwt(idToken));

    useEffect(() => {
        if (!idToken) {
            setUserInfo(null);
            return;
        }

        let timeoutId;
        const decoded = decodeJwt(idToken);
        setUserInfo(decoded);

        if (decoded?.exp) {
            const msUntilExpiry = decoded.exp * 1000 - Date.now();
            if (msUntilExpiry <= 0) {
                setUserInfo(null);
                return;
            }

            timeoutId = window.setTimeout(() => {
                setUserInfo(null);
            }, msUntilExpiry);
        }

        return () => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
        };
    }, [idToken]);

    return {idToken, userInfo};
    }

export default useUser;
